import 'bootstrap/dist/css/bootstrap.min.css';
/* eslint-disable */
import $ from 'jquery';
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React,{ lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import AppWrapper from "./AppWrapper";


const Contexts = lazy(() => import('contexts'));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Contexts>
				<AppWrapper />
			</Contexts>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
